import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

// Content API
export const contentAPI = {
  getAwards: async () => {
    const response = await apiClient.get('/content/awards');
    return response.data.awards;
  },

  getExperiencePillars: async () => {
    const response = await apiClient.get('/content/experience-pillars');
    return response.data.pillars;
  },

  getIndustrySolutions: async () => {
    const response = await apiClient.get('/content/solutions/industry');
    return response.data.solutions;
  },

  getBusinessSolutions: async () => {
    const response = await apiClient.get('/content/solutions/business');
    return response.data.solutions;
  },

  getProducts: async (category = null) => {
    const url = category ? `/content/products?category=${category}` : '/content/products';
    const response = await apiClient.get(url);
    return response.data;
  },

  getServices: async () => {
    const response = await apiClient.get('/content/services');
    return response.data.services;
  },

  getTestimonials: async () => {
    const response = await apiClient.get('/content/testimonials');
    return response.data.testimonials;
  },

  getBlogPosts: async (limit = 10, offset = 0) => {
    const response = await apiClient.get(`/content/blog?limit=${limit}&offset=${offset}`);
    return response.data;
  },

  getAWSBenefits: async () => {
    const response = await apiClient.get('/content/aws-benefits');
    return response.data.benefits;
  },

  getStats: async () => {
    const response = await apiClient.get('/content/stats');
    return response.data.stats;
  },
};

// Forms API
export const formsAPI = {
  submitContact: async (data) => {
    const response = await apiClient.post('/forms/contact', data);
    return response.data;
  },

  subscribeNewsletter: async (email) => {
    const response = await apiClient.post('/forms/newsletter', { email });
    return response.data;
  },

  submitProductInquiry: async (data) => {
    const response = await apiClient.post('/forms/product-inquiry', data);
    return response.data;
  },
};

export default apiClient;